/////////// Utilities

export function round( value, decimals ) {
	return Number( Math.round( value + 'e' + decimals ) + 'e-' + decimals );
}

export function formatDollar( num ) {
	var p = num.toFixed( 2 ).split( "." );
	return p[ 0 ].split( "" ).reverse().reduce( function ( acc, num, i, orig ) {
		return num + ( i && ! ( i % 3 ) ? "," : "" ) + acc;
	}, "" ) + "." + p[ 1 ];
}

export function getSum( total, num ) {
	return total + num;
}

export function modalAnim(x) {
    $('.modal .modal-dialog').attr('class', 'modal-dialog  ' + x + '  animated');
};


